module.exports = __webpack_public_path__ + "static/img/Geoff-Walsh.d332383.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Geoff-Walsh.jpg
// module id = F+As
// module chunks = 1